if (!window.Eurus.loadedScript.has('nutrition-facts-popup.js')) {
  window.Eurus.loadedScript.add('nutrition-facts-popup.js');

  const MOBILE_QUERY = '(max-width: 767px)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const CLOSE_ANIMATION_MS = 300;
  const SWIPE_CLOSE_THRESHOLD = 80;

  class NutritionFactsPopup extends HTMLElement {
    constructor() {
      super();
      this.touchStartY = 0;
      this.touchDeltaY = 0;
      this.isDragging = false;
      this.previouslyFocused = null;

      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleDialogCancel = this.handleDialogCancel.bind(this);
      this.handleDialogClick = this.handleDialogClick.bind(this);
      this.handleDialogClose = this.handleDialogClose.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-nutrition-popup-trigger]');
      this.dialog = this.querySelector('dialog');
      this.panel = this.dialog?.querySelector('.nutrition-facts-popup__panel');
      this.dragZone = this.dialog?.querySelector('.nutrition-facts-popup__drag-zone');
      this.closeButton = this.dialog?.querySelector('.nutrition-facts-popup__close');

      this.trigger?.addEventListener('click', this.handleTriggerClick);
      this.closeButton?.addEventListener('click', this.handleCloseClick);
      this.dialog?.addEventListener('cancel', this.handleDialogCancel);
      this.dialog?.addEventListener('click', this.handleDialogClick);
      this.dialog?.addEventListener('close', this.handleDialogClose);
      this.dragZone?.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.dragZone?.addEventListener('touchmove', this.handleTouchMove, { passive: false });
      this.dragZone?.addEventListener('touchend', this.handleTouchEnd);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.handleTriggerClick);
      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      this.dialog?.removeEventListener('cancel', this.handleDialogCancel);
      this.dialog?.removeEventListener('click', this.handleDialogClick);
      this.dialog?.removeEventListener('close', this.handleDialogClose);
      this.dragZone?.removeEventListener('touchstart', this.handleTouchStart);
      this.dragZone?.removeEventListener('touchmove', this.handleTouchMove);
      this.dragZone?.removeEventListener('touchend', this.handleTouchEnd);
    }

    isMobile() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    prefersReducedMotion() {
      return window.matchMedia(REDUCED_MOTION_QUERY).matches;
    }

    handleTriggerClick() {
      this.open();
    }

    handleCloseClick() {
      this.requestClose();
    }

    handleDialogCancel(event) {
      event.preventDefault();
      this.requestClose();
    }

    handleDialogClick(event) {
      if (event.target === this.dialog) {
        this.requestClose();
      }
    }

    handleDialogClose() {
      document.documentElement.classList.remove('nutrition-facts-popup-open');
      this.previouslyFocused?.focus();
      this.previouslyFocused = null;
    }

    handleTouchStart(event) {
      if (!this.isMobile()) return;
      this.isDragging = true;
      this.touchStartY = event.touches[0].clientY;
      this.touchDeltaY = 0;
    }

    handleTouchMove(event) {
      if (!this.isDragging) return;
      const deltaY = event.touches[0].clientY - this.touchStartY;
      if (deltaY <= 0) return;
      event.preventDefault();
      this.touchDeltaY = deltaY;
      this.panel.style.transform = `translateY(${deltaY}px)`;
    }

    handleTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.panel.style.transform = '';

      if (this.touchDeltaY > SWIPE_CLOSE_THRESHOLD) {
        this.requestClose();
      }
      this.touchDeltaY = 0;
    }

    open() {
      this.previouslyFocused = document.activeElement;
      this.dialog.showModal();
      document.documentElement.classList.add('nutrition-facts-popup-open');
      window.requestAnimationFrame(() => {
        this.dialog.classList.add('is-open');
      });
    }

    requestClose() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      const delay = this.prefersReducedMotion() || !this.isMobile() ? 0 : CLOSE_ANIMATION_MS;
      window.setTimeout(() => {
        this.dialog.close();
      }, delay);
    }
  }

  if (!customElements.get('nutrition-facts-popup')) {
    customElements.define('nutrition-facts-popup', NutritionFactsPopup);
  }
}
